export const deleteAccount = {
  deleteAccountTitle: "Solicitar eliminar cuenta en Raspa y Gana",
  deleteAccountContent: "Si deseas eliminar tu cuenta en Raspa y Gana, por favor envía un correo a",
  deleteAccountInfo: "Nuestro equipo tomará alrededor de 24 horas para resolver tu solicitud.",
  deleteAccountInfo2:
    "Al eliminar la cuenta, toda la información relacionada con tu cuenta será eliminada de forma permanente y no podrá volver a utilizar su cuenta nuevamente.",
};
